import { RootState } from 'types'
import { Action } from 'redux/actions'
import { type TimelineEvent } from 'api/clients/ArticleClient'

export default function reduce(state: RootState['timeline'] = null, action: Action): RootState['timeline'] {
  switch (action.type) {
    case 'TIMELINE_SET': {
      if (action.payload.timeline) {
        const { events, created_at, creator, oldest_timestamp, more_available } = action.payload.timeline
        return {
          ...state,
          events: events,
          created_at: created_at,
          creator: creator,
          oldest_timestamp: oldest_timestamp,
          more_available: more_available,
        }
      } else {
        return state
      }
    }

    case 'LOAD_MORE_ON_TIMELINE': {
      if (state && action.payload.timeline) {
        const { events, oldest_timestamp, more_available } = action.payload.timeline
        return {
          ...state,
          events: state.events.concat(events),
          oldest_timestamp: oldest_timestamp,
          more_available: more_available,
        }
      } else {
        return state
      }
    }

    case 'UPDATE_TIMELINE_EVENT': {
      if (state && action.payload.event) {
        return {
          ...state,
          events: state.events.map((event) =>
            event.id === action.payload.event.id ? (action.payload.event as TimelineEvent) : event,
          ),
        }
      } else {
        return state
      }
    }

    case 'TIMELINE_RESET': {
      return null
    }

    default:
      return state
  }
}
